import React, { useEffect, useState } from 'react'
import { Button } from '@/Components/ui/button'
import { Dialog, DialogContent } from '@/Components/ui/dialog'
import { CircleX, Copy } from 'lucide-react'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import Loader from './Loader'

const ConfirmationPopup = ({ open, setOpen, handleAction, message = '', type = '' }) => {
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        setIsLoading(false)
    }, [open])
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent aria-describedby="Delete-Confirmation" className="sm:max-w-xl translate-y-[-99%]">
                <div className="flex items-center flex-col gap-3 space-x-2">
                    {type == DeleteConfirmationTypeEnum.DELETE && <CircleX color="red" size={50} />}
                    <span className="font-bold text-center">{message}</span>
                    <div className="flex gap-3">
                        {type == DeleteConfirmationTypeEnum.STATUS ? (
                            <>
                                <Button
                                    className="bg-green-600 text-md hover:bg-green-600 px-3 py-2"
                                    disabled={isLoading}
                                    onClick={() => {
                                        setIsLoading(true)
                                        handleAction(true)
                                    }}
                                >
                                    Yes {isLoading && <Loader fullScreen={false} />}
                                </Button>

                                <Button className="bg-red-600 text-md hover:bg-red-600 px-3 py-2" onClick={() => handleAction(false)}>
                                    NO
                                </Button>
                            </>
                        ) : (
                            <>
                               
                                <Button
                                    className="bg-red-600 text-md hover:bg-red-600 px-3 py-2"
                                    disabled={isLoading}
                                    onClick={() => {
                                        setIsLoading(true)
                                        handleAction(true)
                                    }}
                                >
                                    Yes {isLoading && <Loader fullScreen={false} />}
                                </Button>
                                <Button className="bg-green-600 text-md hover:bg-green-600 px-3 py-2" onClick={() => handleAction(false)}>
                                    No
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default ConfirmationPopup
